import React from 'react';
import { Table as AntTable, Space, Popconfirm, Tag } from 'antd';
import { useStateContext } from '../../../../contexts/ContextProvider';

const headerStyle = {
  color: '#525252',
};

const Table = ({ data, onEdit, onDelete, loading, pagination, onPaginationChange, canManage = false }) => {
  const { currentColor } = useStateContext();

  const columns = [
    {
      title: 'ลำดับ',
      align: 'center',
      width: 70,
      key: 'number',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (_, __, index) => {
        const currentPage = pagination?.current || 1;
        const pageSize = pagination?.pageSize || 20;
        return (currentPage - 1) * pageSize + index + 1;
      },
    },
    {
      title: 'เบอร์โทร',
      align: 'center',
      dataIndex: 'phone',
      key: 'phone',
      width: 130,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
    {
      title: 'ชื่อ-นามสกุล',
      align: 'center',
      dataIndex: 'name',
      key: 'name',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
    {
      title: 'ธนาคาร',
      align: 'center',
      dataIndex: 'bank',
      key: 'bank',
      width: 180,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => (text ? <Tag color="blue">{text}</Tag> : '-'),
    },
    {
      title: 'เลขที่บัญชี',
      align: 'center',
      dataIndex: 'bankId',
      key: 'bankId',
      width: 160,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
    // ── ข้อมูลฝั่งเว็บเกม ──
    // บนเว็บต้นทาง ID กับ BETFLIX/SPORTBOOK อยู่ช่องละ 2 ค่า ที่นี่แยกออกมาให้ค้นทีละค่าได้
    {
      title: 'BETFLIX',
      align: 'center',
      dataIndex: 'betflix',
      key: 'betflix',
      width: 160,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
    {
      title: 'SPORTBOOK',
      align: 'center',
      dataIndex: 'sportbook',
      key: 'sportbook',
      width: 170,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
    {
      title: 'รหัสสมาชิก',
      align: 'center',
      dataIndex: 'memberId',
      key: 'memberId',
      width: 140,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
    {
      title: 'ยูสเซอร์',
      align: 'center',
      dataIndex: 'username',
      key: 'username',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => text || '-',
    },
  ];

  // ไม่มีสิทธิ์แก้ = ไม่ต้องมีคอลัมน์นี้เลย (ซ่อนแค่ปุ่มจะเหลือคอลัมน์ว่าง ๆ ดูงง)
  const actionColumn = {
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (record) => (
        <Space size="middle">
          <div className="text-blue-500 cursor-pointer" onClick={() => onEdit(record)}>
            แก้ไข
          </div>
          <Popconfirm
            title="ลบข้อมูล"
            description="ยืนยันการลบข้อมูลธนาคารลูกค้า ?"
            onConfirm={() => onDelete(record)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
            okButtonProps={{ style: { backgroundColor: currentColor, borderColor: currentColor } }}
          >
            <div className="text-red-500 cursor-pointer">ลบ</div>
          </Popconfirm>
        </Space>
      ),
  };

  if (canManage) columns.push(actionColumn);

  return (
    <div className="overflow-x-auto">
      <AntTable
        loading={loading}
        className="border-1 rounded-lg border-gray-200"
        dataSource={data}
        columns={columns}
        pagination={{
          current: pagination?.current || 1,
          pageSize: pagination?.pageSize || 20,
          total: pagination?.total || 0,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} จาก ${total} รายการ`,
          pageSizeOptions: ['20', '50', '100', '200'],
          onChange: (page, pageSize) => onPaginationChange?.(page, pageSize),
        }}
        rowKey={'id'}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default Table;
